<template>
  <div class="fullscreen">
    <!--<div class="text-box" :style="textBoxStyle">
      {{ text[stage] }}
    </div>-->
    <div class="progress-dots-container">
      <div class="dots">
        <div class="dot" :class="{ filled: stage >= 0 }"></div>
        <div class="dot" :class="{ filled: stage >= 1 }"></div>
        <div class="dot" :class="{ filled: stage >= 2 }"></div>
        <div class="dot" :class="{ filled: stage >= 3 }"></div>
        <div class="dot" :class="{ filled: stage >= 4 }"></div>
        <div class="dot" :class="{ filled: stage >= 5 }"></div>
      </div>
    </div>
    <div class="text-box" :style="textBoxStyle">
      <div class="left-control">
        <div
          :class="{ invisible: stage == 0 }"
          class="control icon-throb"
          v-ripple
          @click.stop="prev"
        >
          <svg width="100%" height="100%" viewBox="0 0 24 24">
            <path :d="mdiChevronLeft" fill="#cdf4dd" />
          </svg>
        </div>
      </div>
      <div class="text-inner">
        {{ text[stage] }}
      </div>
      <div class="right-control">
        <div
          id="next-button"
          :class="{ invisible: stage >= text.length - 1 }"
          class="control icon-throb"
          v-ripple
          @click.stop="next"
        >
          <svg width="100%" height="100%" viewBox="0 0 24 24">
            <path :d="mdiChevronRight" fill="#cdf4dd" />
          </svg>
        </div>
      </div>
    </div>
    <div class="hole" :style="holeOneStyle"></div>
    <!-- <div class="control-container" :style="controlContainerStyle">
      <div
        :class="{ invisible: stage == 0 }"
        class="control icon-throb"
        v-ripple
        @click.stop="prev"
      >
        <svg width="100%" height="100%" viewBox="0 0 24 24">
          <path :d="mdiChevronLeft" fill="#cdf4dd" />
        </svg>
      </div>
      <div
        id="next-button"
        :class="{ invisible: stage >= text.length - 1 }"
        class="control icon-throb"
        v-ripple
        @click.stop="next"
      >
        <svg width="100%" height="100%" viewBox="0 0 24 24">
          <path :d="mdiChevronRight" fill="#cdf4dd" />
        </svg>
      </div>
    </div>-->
    <div v-if="stage == text.length - 1" class="bottom">
      <div
        class="button"
        :class="{ throb: stage == text.length - 1 }"
        @click="finishTutorial"
        v-ripple
      >
        Let me try
      </div>
    </div>
  </div>
</template>

<script>
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js'
import gsap from 'gsap'

export default {
  name: 'TutorialCodeScreen',
  data() {
    return {
      mdiChevronLeft,
      mdiChevronRight,
      offset: 10,
      stage: 0,
      text: [
        'These numbers lie still, but not for those who know the secrets. You must find the ways to make them move.',
        "Try tapping, holding and dragging. Some buttons don't move; some do. Maybe not in ways you expect.",
        "Sometimes the number is important. Sometimes it's the position that matters",
        'The bar at the bottom will show you how close you are to a new discovery.',
        "Select here to see what you've discovered and what is left to find.",
        'Hint: you might want to start by dragging this button to the right.',
      ],
      buttonText: [
        'Skip tutorial',
        'Skip tutorial',
        'Skip tutorial',
        'Let me try',
      ],
      timeline: undefined,
    }
  },
  props: {
    positions: Object,
  },
  computed: {
    controlContainerStyle() {
      const offset = this.convertRemToPixels(1)
      if (this.positions['code-container'] === undefined) {
        return {}
      } else {
        return {
          position: 'absolute',
          top: this.positions['code-container'].y - offset + 'px',
          height: this.positions['code-container'].height + 2 * offset + 'px',
        }
      }
    },
    holeOneStyle() {
      let offset = this.convertRemToPixels(1)
      switch (this.stage) {
        case 0:
        case 1:
        case 2:
          offset = this.convertRemToPixels(1)
          if (this.positions['code-container'] === undefined) {
            return {}
          } else {
            return {
              position: 'absolute',
              top: this.positions['code-container'].y - offset + 'px',
              left: this.positions['code-container'].x - offset + 'px',
              width: this.positions['code-container'].width + 2 * offset + 'px',
              height:
                this.positions['code-container'].height + 2 * offset + 'px',
            }
          }
        case 3:
          offset = this.convertRemToPixels(1)
          if (this.positions['progress'] === undefined) {
            return {}
          } else {
            return {
              position: 'absolute',
              top: this.positions['progress'].y - offset + 'px',
              left: this.positions['progress'].x - offset + 'px',
              width: this.positions['progress'].width + 2 * offset + 'px',
              height: this.positions['progress'].height + 2 * offset + 'px',
            }
          }
        case 4:
          offset = this.convertRemToPixels(0.5)
          if (this.positions['library-icon'] === undefined) {
            return {}
          } else {
            return {
              position: 'absolute',
              top: this.positions['library-icon'].y - offset + 'px',
              left: this.positions['library-icon'].x - offset + 'px',
              width: this.positions['library-icon'].width + 2 * offset + 'px',
              height: this.positions['library-icon'].height + 2 * offset + 'px',
            }
          }
        case 5:
          offset = this.convertRemToPixels(0.5)
          if (this.positions['button-6'] === undefined) {
            return {}
          } else {
            return {
              position: 'absolute',
              top: this.positions['button-6'].y - offset + 'px',
              left: this.positions['button-6'].x - offset + 'px',
              width: this.positions['button-6'].width + 2 * offset + 'px',
              height: this.positions['button-6'].height + 2 * offset + 'px',
            }
          }
        default:
          return {}
      }
    },
    textBoxStyle() {
      let offset
      switch (this.stage) {
        case 0:
        case 1:
        case 2:
          offset = this.convertRemToPixels(1)
          if (this.positions['code-container'] === undefined) {
            return {}
          } else {
            return {
              position: 'absolute',
              bottom: `calc(100% - ${this.holeOneStyle.top} + ${offset}px`,
              /*bottom:
                this.positions['code-container'].y +
                this.positions['code-container'].height +
                3 * this.convertRemToPixels(1) +
                'px',*/
            }
          }
        case 3:
          offset = this.convertRemToPixels(1)
          return {
            position: 'absolute',
            bottom: `calc(100% - ${this.holeOneStyle.top} + ${offset}px)`,
          }
        case 4:
          offset = this.convertRemToPixels(1)
          return {
            position: 'absolute',
            top: `calc(${this.holeOneStyle.top} + ${this.holeOneStyle.height} + ${offset}px)`,
          }
        case 5:
          offset = this.convertRemToPixels(1)
          return {
            position: 'absolute',
            bottom: `calc(100% - ${this.holeOneStyle.top} + ${offset}px)`,
          }
        /*if (this.positions['code-container'] === undefined) {
            return {}
          } else {
            return {
              position: 'absolute',
              bottom:
                this.positions['code-container'].y +
                this.positions['code-container'].height +
                3 * this.convertRemToPixels(1) +
                'px',
            }
          }*/
        default:
          return {}
      }
    },
  },
  watch: {
    stage(new_val) {
      if (new_val == 3) {
        const that = this
        const progressTweener = {
          _progress: 0,
          set progress(val) {
            that.$store.commit('SET_UNLOCK_PROGRESS', +val)
            this._progress = +val
            //console.log('tweened to:', +val)
          },
          get progress() {
            return this._progress
          },
        }
        this.timeline = gsap.timeline({ repeat: -1, yoyo: false })
        this.timeline.fromTo(
          progressTweener,
          { progress: 0 },
          { progress: 0, duration: 0.5, ease: 'linear' }
        )
        this.timeline.fromTo(
          progressTweener,
          { progress: 0 },
          { progress: 100, duration: 1.5, ease: 'linear' }
        )
        this.timeline.fromTo(
          progressTweener,
          { progress: 100 },
          { progress: 100, duration: 0.7, ease: 'linear' }
        )
        this.timeline.play()
      } else {
        if (!(this.timeline === undefined)) {
          this.timeline.kill()
          this.$store.commit('SET_UNLOCK_PROGRESS', 0)
          this.timeline = undefined
        }
      }
    },
  },
  methods: {
    next() {
      this.fadeTextOutIn(() => {
        this.stage += 1
        //this.$store.commit('SET_TUTORIAL_STAGE', this.stage + 1)
      })
    },
    prev() {
      this.fadeTextOutIn(() => {
        this.stage -= 1
        //this.$store.commit('SET_TUTORIAL_STAGE', this.stage - 1)
      })
    },
    fadeTextOutIn(onComplete) {
      const tl = gsap.timeline({ repeat: 0 })

      tl.to('.text-box', {
        opacity: 0,
        duration: 0.4,
        onComplete,
      })
      tl.to('.text-box', {
        opacity: 1,
        duration: 0.4,
      })
    },
    convertRemToPixels(rem) {
      return (
        rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
      )
    },
    finishTutorial() {
      this.$store.commit('SET_MAIN_TUTORIAL_SEEN', true)
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.fullscreen {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: 100%;
  width: 100%;
  background: transparent;
}

.button {
  display: block;
  padding: 1em;
  text-align: center;
  border: 1px solid #cdf4dd;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.5s ease, color 0.5s ease;
  color: #cdf4dd;
  font-family: 'Montserrat', sans-serif;
}

.hole {
  border-radius: 10px;
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.8);
  transition: width 0.5s, height 0.5s, top 0.5s, bottom 0.5s, left 0.5s,
    right 0.5s;
}

.text-box {
  /*width: calc(100% - 4rem);*/
  width: 100%;
  max-width: 30rem;
  color: #cdf4dd;
  font-family: 'Montserrat', sans-serif;
  z-index: 98;
  text-align: center;
  padding-bottom: 1rem;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-top: 1rem;
  /*outline: 1px solid red;*/
}

.left-control,
.right-control {
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.text-inner {
  flex-grow: 1;
  padding-left: 1rem;
  padding-right: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.control-container {
  /*width: calc(100% - 4rem);
  max-width: 30rem;*/
  width: 100%;
  max-width: 30rem;
  /*outline: 1px solid green;*/
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  /*padding-left: 1rem;
  padding-right: 1rem;*/
  box-sizing: border-box;
}

.control {
  color: #cdf4dd;
  font-family: 'Montserrat', sans-serif;
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  cursor: pointer;
}

.invisible {
  visibility: hidden;
}

.bottom {
  position: absolute;
  bottom: 2rem;
  max-width: 20rem;
  width: calc(100% - 4rem);
}

.bottom > * + * {
  margin-top: 1rem;
}

@media (hover: hover) {
  .button:hover {
    background-color: rgba(204, 244, 221, 0.1);
  }
}

.button.throb {
  animation-name: button-throb-animation;
  animation-duration: 0.75s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  transform-origin: center;
}

@keyframes button-throb-animation {
  from {
    background-color: transparent;
  }
  to {
    background-color: rgba(224, 168, 0, 0.3);
  }
}

.icon-throb path {
  animation-name: icon-throb-animation;
  animation-duration: 0.5s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  transform-origin: center;
}

@keyframes icon-throb-animation {
  from {
    /*fill: #cdf4dd;*/
    transform: scale(1);
  }
  to {
    /*fill: #e0a800;*/
    transform: scale(1.2);
  }
}

.progress-dots-container {
  height: 2rem;
  width: 100%;
  color: #cdf4dd;
  font-family: 'Montserrat', sans-serif;
  position: absolute;
  top: 0.5rem;
  z-index: 98;
}

.dots {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.dots > * + * {
  margin-left: 0.5rem;
}

.dot {
  border-radius: 50%;
  height: 0.7rem;
  width: 0.7rem;
  border: 1px solid #cdf4dd;
}

.filled {
  background-color: #cdf4dd;
}
</style>
